module.exports = __webpack_public_path__ + "img/C07TechBerserkerChampion_ua.0d977d37.webp";